// extracted by mini-css-extract-plugin
export default {"comp":"ButtonGroup_comp__KCHzc","vertical":"ButtonGroup_vertical__Gp1az","horizontal":"ButtonGroup_horizontal__3kPOU","ratio":"ButtonGroup_ratio__P-SNk"};